import { render, staticRenderFns } from "./proof-view-comment.vue?vue&type=template&id=0d7411a5&scoped=true&"
import script from "./proof-view-comment.vue?vue&type=script&lang=js&"
export * from "./proof-view-comment.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-comment.vue?vue&type=style&index=0&id=0d7411a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7411a5",
  null
  
)

export default component.exports